import { render } from "./WeekResources.vue?vue&type=template&id=df369aca&scoped=true"
import script from "./WeekResources.vue?vue&type=script&lang=js"
export * from "./WeekResources.vue?vue&type=script&lang=js"

import "./WeekResources.vue?vue&type=style&index=0&id=df369aca&lang=scss&scoped=true"
import "./WeekResources.vue?vue&type=style&index=1&id=df369aca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df369aca"]])

export default __exports__